import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { Box, ButtonAlpha, SelectionCard, StackBlock, StackInline, TextAlpha } from '@yonderland/andes-react';
import { useTranslation } from 'react-i18next';
import { DeliveryOptionsEnum } from '@as-react/common-types';
import { useDeliveryState } from '../../../../context/CheckoutDeliveryContext';
import { useQuery } from '@tanstack/react-query';
import { checkoutQueries } from '@as-react/common-queries';
import { useAemConfig } from '@as-react/common-components';
import { I18N_NAMESPACES } from '../../../../constants/i18nConstants';
import { useState } from 'react';
import { DeliverySheet } from '../DeliverySheet';
import { formatTimeStampToDateParts, isTomorrow } from '../../../../util/DateUtil';
const DeliveryDateLabel = ({ date, locale, customWeekday }) => {
    const { weekday, day, month } = formatTimeStampToDateParts(date, locale, {
        weekday: 'long',
        day: 'numeric',
        month: 'short',
    });
    return (_jsxs(StackInline, { itemsAlign: "center", contentAlign: "center", gap: "2", children: [_jsxs(TextAlpha, { strong: true, children: [customWeekday || weekday, " "] }), _jsx(TextAlpha, { variant: "bodyXS", as: "span", children: `${day} ${month}` })] }));
};
const showDeliveryDates = (options) => options.some(opt => opt.name === DeliveryOptionsEnum.NAMED_DAY || (opt.name === DeliveryOptionsEnum.NEXT_DAY && opt.namedDayEnabled));
export const HomeDeliveryDaySelector = () => {
    const { t } = useTranslation(I18N_NAMESPACES.checkout);
    const aemConfiguration = useAemConfig();
    const { defaultRequestParams, servicesEndpoint } = aemConfiguration;
    const [{ info, openSelector }, dispatch] = useDeliveryState();
    const isOpen = openSelector === 'delivery-day';
    const [selectedDay, setSelectedDay] = useState();
    const { getNamedDayDeliveryDates } = checkoutQueries({ servicesEndpoint, defaultRequestParams });
    const { data: deliveryDates } = useQuery(getNamedDayDeliveryDates({
        enabled: showDeliveryDates(info.deliveryOptions),
    }));
    const selectDeliveryDay = () => {
        if (!selectedDay) {
            return;
        }
        dispatch({ type: 'select_delivery_day', payload: selectedDay.date });
        dispatch({ type: 'set_open_selector', payload: undefined });
    };
    const cancelDeliveryDayChange = () => {
        dispatch({ type: 'set_open_selector', payload: undefined });
    };
    const handleClickDate = (deliveryDate) => {
        setSelectedDay(deliveryDate);
    };
    const getContent = () => (_jsx(Box, { paddingBlockEnd: "4", children: _jsxs(StackBlock, { gap: "6", children: [_jsx(TextAlpha, { variant: "headingS", children: t('checkout.delivery.delivery.day.flyout.title') }), _jsx(StackBlock, { gap: "4", children: deliveryDates === null || deliveryDates === void 0 ? void 0 : deliveryDates.map((deliveryDate, index) => (_jsx(SelectionCard, { testId: "hd_date_option", state: selectedDay && selectedDay === deliveryDate ? 'active' : 'resting', onClick: () => handleClickDate(deliveryDate), children: _jsx(SelectionCard.Cell, { section: "content", cellProps: {
                                align: 'center',
                            }, children: _jsx(DeliveryDateLabel, { date: deliveryDate.date, locale: aemConfiguration.locale, customWeekday: index === 0 && isTomorrow(deliveryDate.date)
                                    ? t('checkout.delivery.delivery.day.tomorrow')
                                    : undefined }) }) }, deliveryDate.date))) })] }) }));
    const getCTAContent = () => (_jsx(ButtonAlpha, { fullWidth: true, testId: "hd_select_delivery_date", theme: "branded", text: t('checkout.delivery.delivery.day.flyout.confirm'), onClick: selectDeliveryDay }));
    return DeliverySheet({
        isOpen,
        onClose: cancelDeliveryDayChange,
        getContent,
        showCTA: !!selectedDay,
        getCTAContent,
    });
};
